import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 17H16M11.0177 2.76401L4.23539 8.03914C3.78202 8.39176 3.55534 8.56807 3.39203 8.78887C3.24737 8.98446 3.1396 9.2048 3.07403 9.43907C3 9.70354 3 9.99071 3 10.5651V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V10.5651C21 9.99071 21 9.70354 20.926 9.43907C20.8604 9.2048 20.7526 8.98446 20.608 8.78887C20.4447 8.56807 20.218 8.39176 19.7646 8.03914L12.9823 2.76402C12.631 2.49076 12.4553 2.35414 12.2613 2.30162C12.0902 2.25528 11.9098 2.25528 11.7387 2.30162C11.5447 2.35414 11.369 2.49076 11.0177 2.76401Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 13V15M10 9V15M14 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 12L11.6422 16.8211C11.7734 16.8867 11.839 16.9195 11.9078 16.9324C11.9687 16.9438 12.0313 16.9438 12.0922 16.9324C12.161 16.9195 12.2266 16.8867 12.3578 16.8211L22 12M2 17L11.6422 21.8211C11.7734 21.8867 11.839 21.9195 11.9078 21.9324C11.9687 21.9438 12.0313 21.9438 12.0922 21.9324C12.161 21.9195 12.2266 21.8867 12.3578 21.8211L22 17M2 7L11.6422 2.17888C11.7734 2.11329 11.839 2.0805 11.9078 2.06759C11.9687 2.05616 12.0313 2.05616 12.0922 2.06759C12.161 2.0805 12.2266 2.11329 12.3578 2.17888L22 7L12.3578 11.8211C12.2266 11.8867 12.161 11.9195 12.0922 11.9324C12.0313 11.9438 11.9687 11.9438 11.9078 11.9324C11.839 11.9195 11.7734 11.8867 11.6422 11.8211L2 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 12H18L15 21L9 3L6 12H2",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38643 22 10.6868 22 12M12 2V12M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5229 22 12M12 2C17.5228 2 22 6.47716 22 12M22 12L12 12M22 12C22 13.5781 21.6265 15.1338 20.9101 16.5399C20.1936 17.946 19.1546 19.1626 17.8779 20.0902L12 12",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 7,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 8,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 9,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 10,
  class: "text-transparent",
  width: "61",
  height: "60",
  viewBox: "0 0 61 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.898438\" y=\"0.238281\" width=\"59.7556\" height=\"59.7556\" rx=\"13.8258\" fill=\"#1570EF\"></rect><path d=\"M9.03931 19.2509C9.03931 13.2503 13.9038 8.38574 19.9045 8.38574V19.2509H9.03931Z\" fill=\"white\"></path><path d=\"M9.03931 40.98H19.9045V51.8452C13.9038 51.8452 9.03931 46.9807 9.03931 40.98Z\" fill=\"white\"></path><path d=\"M30.7705 19.25C36.7712 19.25 41.6357 24.1145 41.6357 30.1152H30.7705V19.25Z\" fill=\"white\"></path><path d=\"M30.7705 30.1172H41.6357C41.6357 36.1179 36.7712 40.9824 30.7705 40.9824V30.1172Z\" fill=\"white\"></path><path d=\"M19.9075 30.1152C19.9075 24.1145 24.772 19.25 30.7727 19.25V30.1152H19.9075Z\" fill=\"white\"></path><path d=\"M19.9075 30.1172H30.7727V40.9824C24.772 40.9824 19.9075 36.1179 19.9075 30.1172Z\" fill=\"white\"></path><path d=\"M41.6387 8.38574C47.6394 8.38574 52.5039 13.2503 52.5039 19.2509H41.6387V8.38574Z\" fill=\"white\"></path><path d=\"M9.03784 30.1152C9.03784 24.1145 13.9024 19.25 19.903 19.25V30.1152H9.03784Z\" fill=\"white\"></path><path d=\"M9.03784 30.1143H19.903V40.9795C13.9024 40.9795 9.03784 36.1149 9.03784 30.1143Z\" fill=\"white\"></path><path d=\"M41.6323 19.25C47.633 19.25 52.4975 24.1145 52.4975 30.1152H41.6323V19.25Z\" fill=\"white\"></path><path d=\"M41.6323 30.1143H52.4975C52.4975 36.1149 47.633 40.9795 41.6323 40.9795V30.1143Z\" fill=\"white\"></path><path d=\"M30.7661 51.8457C24.7654 51.8457 19.9009 46.9812 19.9009 40.9805L30.7661 40.9805L30.7661 51.8457Z\" fill=\"white\"></path><path d=\"M30.769 51.8457L30.769 40.9805L41.6342 40.9805C41.6342 46.9812 36.7697 51.8457 30.769 51.8457Z\" fill=\"white\"></path><path d=\"M19.9009 19.2515C19.9009 13.2508 24.7654 8.38626 30.7661 8.38626L30.7661 19.2515L19.9009 19.2515Z\" fill=\"white\"></path><path d=\"M30.769 19.2515L30.769 8.38626C36.7697 8.38626 41.6342 13.2508 41.6342 19.2515L30.769 19.2515Z\" fill=\"white\"></path><path d=\"M41.6387 40.98H52.5039C52.5039 46.9807 47.6394 51.8452 41.6387 51.8452V40.98Z\" fill=\"white\"></path>", 17)
const _hoisted_50 = [
  _hoisted_33
]
const _hoisted_51 = {
  key: 11,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.046875\" y=\"0.238281\" width=\"59.8803\" height=\"59.7559\" rx=\"13.8259\" fill=\"#099250\"></rect><ellipse cx=\"15.4685\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"29.984\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.505\" cy=\"15.6311\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"15.4685\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.505\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"30.1098\" cy=\"30.1179\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"15.4685\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"29.984\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse><ellipse cx=\"44.4995\" cy=\"44.6032\" rx=\"7.25845\" ry=\"7.24336\" fill=\"#EDFCF2\"></ellipse>", 10)
const _hoisted_62 = [
  _hoisted_52
]
const _hoisted_63 = {
  key: 12,
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 5V4M7 9.5V8.5M7 14V13M5.8 17H16.2C17.8802 17 18.7202 17 19.362 16.673C19.9265 16.3854 20.3854 15.9265 20.673 15.362C21 14.7202 21 13.8802 21 12.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V12.2C1 13.8802 1 14.7202 1.32698 15.362C1.6146 15.9265 2.07354 16.3854 2.63803 16.673C3.27976 17 4.11984 17 5.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = {
  key: 13,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.0786 9.35766C5.0268 9.02385 4.99993 8.68187 4.99993 8.33366C4.99993 4.65176 8.00433 1.66699 11.7105 1.66699C15.4166 1.66699 18.421 4.65176 18.421 8.33366C18.421 9.16539 18.2677 9.96154 17.9876 10.6957C17.9294 10.8482 17.9003 10.9245 17.8871 10.984C17.874 11.043 17.869 11.0845 17.8676 11.1449C17.8661 11.2058 17.8744 11.273 17.8909 11.4073L18.2264 14.1324C18.2627 14.4274 18.2809 14.5749 18.2318 14.6822C18.1888 14.7761 18.1125 14.8508 18.0175 14.8916C17.9092 14.9382 17.7621 14.9166 17.4681 14.8735L14.8137 14.4844C14.6751 14.4641 14.6058 14.4539 14.5427 14.4543C14.4802 14.4547 14.437 14.4593 14.3759 14.4721C14.3142 14.4851 14.2353 14.5147 14.0774 14.5738C13.3414 14.8495 12.5436 15.0003 11.7105 15.0003C11.362 15.0003 11.0197 14.9739 10.6855 14.9231M6.35961 18.3337C8.83036 18.3337 10.8333 16.2816 10.8333 13.7503C10.8333 11.219 8.83036 9.16699 6.35961 9.16699C3.88886 9.16699 1.88592 11.219 1.88592 13.7503C1.88592 14.2592 1.96686 14.7486 2.11625 15.2059C2.1794 15.3992 2.21098 15.4959 2.22134 15.5619C2.23216 15.6309 2.23406 15.6696 2.23003 15.7393C2.22617 15.806 2.20947 15.8814 2.17608 16.0323L1.66663 18.3337L4.16229 17.9928C4.29851 17.9742 4.36662 17.9649 4.4261 17.9653C4.48873 17.9657 4.52196 17.9691 4.58338 17.9814C4.64171 17.993 4.72843 18.0236 4.90185 18.0848C5.35879 18.2461 5.84922 18.3337 6.35961 18.3337Z",
  stroke: "currentColor",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 14,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1040_5920)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1040_5920" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = {
  key: 15,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5",
  stroke: "#475467",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  key: 16,
  class: "animate-spin",
  viewBox: "0 0 100 100"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("circle", {
  fill: "none",
  "stroke-width": "10",
  class: "stroke-current opacity-40",
  cx: "50",
  cy: "50",
  r: "40"
}, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("circle", {
  fill: "none",
  "stroke-width": "10",
  class: "stroke-current",
  "stroke-dasharray": "250",
  "stroke-dashoffset": "210",
  cx: "50",
  cy: "50",
  r: "40"
}, null, -1)
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = {
  key: 17,
  xmlns: "http://www.w3.org/2000/svg",
  class: "block w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("path", { d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" }, null, -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 18,
  width: "24",
  height: "20",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.66675 3.83325L8.47085 8.59612C9.02182 8.9818 9.29731 9.17465 9.59697 9.24934C9.86166 9.31532 10.1385 9.31532 10.4032 9.24934C10.7029 9.17465 10.9783 8.9818 11.5293 8.59612L18.3334 3.83325M5.66675 14.6666H14.3334C15.7335 14.6666 16.4336 14.6666 16.9684 14.3941C17.4388 14.1544 17.8212 13.772 18.0609 13.3016C18.3334 12.7668 18.3334 12.0667 18.3334 10.6666V5.33325C18.3334 3.93312 18.3334 3.23306 18.0609 2.69828C17.8212 2.22787 17.4388 1.84542 16.9684 1.60574C16.4336 1.33325 15.7335 1.33325 14.3334 1.33325H5.66675C4.26662 1.33325 3.56655 1.33325 3.03177 1.60574C2.56137 1.84542 2.17892 2.22787 1.93923 2.69828C1.66675 3.23306 1.66675 3.93312 1.66675 5.33325V10.6666C1.66675 12.0667 1.66675 12.7668 1.93923 13.3016C2.17892 13.772 2.56137 14.1544 3.03177 14.3941C3.56655 14.6666 4.26662 14.6666 5.66675 14.6666Z",
  stroke: "#667085",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = {
  key: 19,
  width: "26",
  height: "31",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("g", { id: "ic:baseline-delete-outline" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M9.28247 6.60547H11.7166C11.7166 6.28269 11.5883 5.97313 11.3601 5.74489C11.1319 5.51665 10.8223 5.38843 10.4995 5.38843C10.1767 5.38843 9.86717 5.51665 9.63893 5.74489C9.41069 5.97313 9.28247 6.28269 9.28247 6.60547ZM8.55225 6.60547C8.55225 6.08902 8.7574 5.59373 9.12259 5.22854C9.48777 4.86336 9.98306 4.6582 10.4995 4.6582C11.016 4.6582 11.5113 4.86336 11.8764 5.22854C12.2416 5.59373 12.4468 6.08902 12.4468 6.60547H15.4894C15.5862 6.60547 15.6791 6.64394 15.7476 6.71241C15.816 6.78088 15.8545 6.87375 15.8545 6.97058C15.8545 7.06741 15.816 7.16028 15.7476 7.22875C15.6791 7.29723 15.5862 7.33569 15.4894 7.33569H14.8517L14.2592 14.4447C14.2161 14.9618 13.9802 15.4439 13.5983 15.7953C13.2165 16.1467 12.7165 16.3418 12.1975 16.3418H8.8015C8.28255 16.3418 7.78256 16.1467 7.40068 15.7953C7.01881 15.4439 6.78293 14.9618 6.73983 14.4447L6.14737 7.33569H5.50964C5.41281 7.33569 5.31994 7.29723 5.25147 7.22875C5.183 7.16028 5.14453 7.06741 5.14453 6.97058C5.14453 6.87375 5.183 6.78088 5.25147 6.71241C5.31994 6.64394 5.41281 6.60547 5.50964 6.60547H8.55225ZM7.46762 14.3838C7.49546 14.7185 7.64804 15.0304 7.89512 15.2578C8.14219 15.4852 8.4657 15.6115 8.8015 15.6116H12.1975C12.5333 15.6115 12.8568 15.4852 13.1039 15.2578C13.351 15.0304 13.5036 14.7185 13.5314 14.3838L14.1195 7.33569H6.88003L7.46762 14.3838ZM9.40417 9.03955C9.50101 9.03955 9.59388 9.07802 9.66235 9.14649C9.73082 9.21496 9.76929 9.30783 9.76929 9.40466V13.5426C9.76929 13.6394 9.73082 13.7323 9.66235 13.8008C9.59388 13.8692 9.50101 13.9077 9.40417 13.9077C9.30734 13.9077 9.21447 13.8692 9.146 13.8008C9.07753 13.7323 9.03906 13.6394 9.03906 13.5426V9.40466C9.03906 9.30783 9.07753 9.21496 9.146 9.14649C9.21447 9.07802 9.30734 9.03955 9.40417 9.03955ZM11.96 9.40466C11.96 9.30783 11.9215 9.21496 11.853 9.14649C11.7846 9.07802 11.6917 9.03955 11.5948 9.03955C11.498 9.03955 11.4051 9.07802 11.3367 9.14649C11.2682 9.21496 11.2297 9.30783 11.2297 9.40466V13.5426C11.2297 13.6394 11.2682 13.7323 11.3367 13.8008C11.4051 13.8692 11.498 13.9077 11.5948 13.9077C11.6917 13.9077 11.7846 13.8692 11.853 13.8008C11.9215 13.7323 11.96 13.6394 11.96 13.5426V9.40466Z",
    fill: "#FD87B4"
  })
], -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = {
  key: 20,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
  stroke: "#475467",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = {
  key: 21,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "48",
  rx: "24",
  fill: "#EFF4FF"
}, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31 24H17M17 24L24 31M17 24L24 17",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_95 = [
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = {
  key: 22,
  width: "42",
  height: "42",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
  fill: "#F2F4F7"
}, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.25 16C0.25 7.30152 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30152 31.75 16C31.75 24.6985 24.6985 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16Z",
  stroke: "black",
  "stroke-opacity": "0.08",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.6667 23.5C22.6667 22.337 22.6667 21.7555 22.5232 21.2824C22.2 20.217 21.3663 19.3834 20.301 19.0602C19.8278 18.9167 19.2463 18.9167 18.0834 18.9167H13.9167C12.7537 18.9167 12.1723 18.9167 11.6991 19.0602C10.6338 19.3834 9.80007 20.217 9.47691 21.2824C9.33337 21.7555 9.33337 22.337 9.33337 23.5M19.75 12.25C19.75 14.3211 18.0711 16 16 16C13.929 16 12.25 14.3211 12.25 12.25C12.25 10.1789 13.929 8.5 16 8.5C18.0711 8.5 19.75 10.1789 19.75 12.25Z",
  stroke: "#667085",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_100 = [
  _hoisted_97,
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = {
  key: 23,
  class: "cursor-pointer",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18M6 6L18 18",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 24,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#DCFAE6"
}, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 15V18.4C19 18.9601 19 19.2401 19.109 19.454C19.2049 19.6422 19.3578 19.7951 19.546 19.891C19.7599 20 20.0399 20 20.6 20H27.4C27.9601 20 28.2401 20 28.454 19.891C28.6422 19.7951 28.7951 19.6422 28.891 19.454C29 19.2401 29 18.9601 29 18.4V16M29 33V26.6C29 26.0399 29 25.7599 28.891 25.546C28.7951 25.3578 28.6422 25.2049 28.454 25.109C28.2401 25 27.9601 25 27.4 25H20.6C20.0399 25 19.7599 25 19.546 25.109C19.3578 25.2049 19.2049 25.3578 19.109 25.546C19 25.7599 19 26.0399 19 26.6V33M33 21.3255V28.2C33 29.8802 33 30.7202 32.673 31.362C32.3854 31.9265 31.9265 32.3854 31.362 32.673C30.7202 33 29.8802 33 28.2 33H19.8C18.1198 33 17.2798 33 16.638 32.673C16.0735 32.3854 15.6146 31.9265 15.327 31.362C15 30.7202 15 29.8802 15 28.2V19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15H26.6745C27.1637 15 27.4083 15 27.6385 15.0553C27.8425 15.1043 28.0376 15.1851 28.2166 15.2947C28.4184 15.4184 28.5914 15.5914 28.9373 15.9373L32.0627 19.0627C32.4086 19.4086 32.5816 19.5816 32.7053 19.7834C32.8149 19.9624 32.8957 20.1575 32.9447 20.3615C33 20.5917 33 20.8363 33 21.3255Z",
  stroke: "#079455",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  key: 25,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#FEE4E2"
}, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
  stroke: "#D92D20",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_111 = [
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = {
  key: 26,
  class: "cursor-pointer",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_843_13544)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.05992 6.00016C6.21665 5.55461 6.52602 5.1789 6.93322 4.93958C7.34042 4.70027 7.81918 4.61279 8.2847 4.69264C8.75022 4.77249 9.17246 5.01451 9.47664 5.37585C9.78081 5.73718 9.94729 6.19451 9.94659 6.66683C9.94659 8.00016 7.94659 8.66683 7.94659 8.66683M7.99992 11.3335H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z",
    stroke: "#98A2B3",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_843_13544" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_115 = [
  _hoisted_113,
  _hoisted_114
]
const _hoisted_116 = {
  key: 27,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#DCFAE6"
}, null, -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 24L22.5 27L28.5 21M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
  stroke: "#079455",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_119 = [
  _hoisted_117,
  _hoisted_118
]
const _hoisted_120 = {
  key: 28,
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_121 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_20365_3025)\"><path d=\"M57.1433 2.28516H6.85756C5.64514 2.28516 4.48238 2.76679 3.62507 3.6241C2.76776 4.48141 2.28613 5.64417 2.28613 6.85658V45.7137C2.28613 46.9261 2.76776 48.0889 3.62507 48.9462C4.48238 49.8035 5.64514 50.2852 6.85756 50.2852H16.0004V61.7137L30.2633 50.2852H57.1433C58.3557 50.2852 59.5185 49.8035 60.3758 48.9462C61.2331 48.0889 61.7147 46.9261 61.7147 45.7137V6.85658C61.7147 5.64417 61.2331 4.48141 60.3758 3.6241C59.5185 2.76679 58.3557 2.28516 57.1433 2.28516Z\" stroke=\"#4B5563\" stroke-width=\"4.57143\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M25.1426 20.572C25.1426 19.2158 25.5447 17.89 26.2982 16.7624C27.0517 15.6347 28.1226 14.7558 29.3756 14.2368C30.6286 13.7178 32.0073 13.582 33.3375 13.8466C34.6676 14.1112 35.8895 14.7643 36.8485 15.7233C37.8074 16.6822 38.4605 17.9041 38.7251 19.2342C38.9897 20.5644 38.8539 21.9431 38.3349 23.1961C37.8159 24.4491 36.937 25.52 35.8093 26.2735C34.6817 27.027 33.3559 27.4291 31.9997 27.4291V29.7148\" stroke=\"#4B5563\" stroke-width=\"4.57143\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M31.9999 36.5723C31.3218 36.5723 30.6589 36.7733 30.0951 37.1501C29.5312 37.5268 29.0918 38.0623 28.8323 38.6888C28.5728 39.3153 28.5049 40.0046 28.6372 40.6697C28.7695 41.3348 29.096 41.9457 29.5755 42.4252C30.055 42.9047 30.6659 43.2312 31.331 43.3635C31.9961 43.4958 32.6854 43.4279 33.3119 43.1684C33.9384 42.9089 34.4739 42.4695 34.8506 41.9056C35.2274 41.3418 35.4284 40.6789 35.4284 40.0008C35.4166 39.0952 35.0516 38.23 34.4111 37.5896C33.7707 36.9491 32.9055 36.5841 31.9999 36.5723Z\" fill=\"#4B5563\"></path></g><defs><clipPath id=\"clip0_20365_3025\"><rect width=\"64\" height=\"64\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_123 = [
  _hoisted_121
]
const _hoisted_124 = {
  key: 29,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.66675 13.3333L10.0001 10M10.0001 10L13.3334 13.3333M10.0001 10V17.5M16.6667 13.9524C17.6847 13.1117 18.3334 11.8399 18.3334 10.4167C18.3334 7.88536 16.2814 5.83333 13.7501 5.83333C13.568 5.83333 13.3976 5.73833 13.3052 5.58145C12.2185 3.73736 10.2121 2.5 7.91675 2.5C4.46497 2.5 1.66675 5.29822 1.66675 8.75C1.66675 10.4718 2.36295 12.0309 3.48921 13.1613",
  stroke: "#344054",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = {
  key: 30,
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_128 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 7L7 1L1 7",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = {
  key: 31,
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_131 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 1L7 7L13 1",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = {
  key: 32,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#DCFAE6"
}, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("path", {
  d: "M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
  stroke: "#079455",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_136 = [
  _hoisted_134,
  _hoisted_135
]
const _hoisted_137 = {
  key: 33,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("g", { id: "trophy-01" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Icon",
    d: "M12 15C8.68629 15 6 12.3137 6 9V3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15ZM12 15V18M18 4H20.5C20.9659 4 21.1989 4 21.3827 4.07612C21.6277 4.17761 21.8224 4.37229 21.9239 4.61732C22 4.80109 22 5.03406 22 5.5V6C22 6.92997 22 7.39496 21.8978 7.77646C21.6204 8.81173 20.8117 9.62038 19.7765 9.89778C19.395 10 18.93 10 18 10M6 4H3.5C3.03406 4 2.80109 4 2.61732 4.07612C2.37229 4.17761 2.17761 4.37229 2.07612 4.61732C2 4.80109 2 5.03406 2 5.5V6C2 6.92997 2 7.39496 2.10222 7.77646C2.37962 8.81173 3.18827 9.62038 4.22354 9.89778C4.60504 10 5.07003 10 6 10M7.44444 22H16.5556C16.801 22 17 21.801 17 21.5556C17 19.5919 15.4081 18 13.4444 18H10.5556C8.59188 18 7 19.5919 7 21.5556C7 21.801 7.19898 22 7.44444 22Z",
    stroke: "#079455",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = {
  key: 34,
  width: "24",
  height: "21",
  viewBox: "0 0 24 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 8L12 13L17 8H7Z",
  fill: "#101828"
}, null, -1)
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = {
  key: 35,
  width: "24",
  height: "21",
  viewBox: "0 0 24 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_144 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 13L12 8L17 13H7Z",
  fill: "#101828"
}, null, -1)
const _hoisted_145 = [
  _hoisted_144
]
const _hoisted_146 = {
  key: 36,
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}
const _hoisted_147 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
  stroke: "#344054",
  "stroke-width": "1.58333",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = {
  key: 37,
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("rect", {
  width: "15",
  height: "15",
  rx: "7.5",
  fill: "#FDA29B"
}, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.03125 9.0625V3.125H7.96875V9.0625H7.03125ZM7.03125 11.875V10.9375H7.96875V11.875H7.03125Z",
  fill: "white"
}, null, -1)
const _hoisted_152 = [
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = {
  key: 38,
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("rect", {
  width: "15",
  height: "15",
  rx: "7.5",
  fill: "#FDE68A"
}, null, -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5 4V8M7.5 10H7.51",
  stroke: "#92400E",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_156 = [
  _hoisted_154,
  _hoisted_155
]
const _hoisted_157 = {
  key: 39,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_158 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5",
  stroke: "#344054",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_159 = [
  _hoisted_158
]
const _hoisted_160 = {
  key: 40,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_161 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.39668 15.0964C2.43497 14.7518 2.45411 14.5795 2.50624 14.4185C2.55249 14.2756 2.61784 14.1396 2.70051 14.0143C2.79369 13.873 2.91627 13.7504 3.16142 13.5052L14.1667 2.49999C15.0871 1.57952 16.5795 1.57952 17.5 2.5C18.4205 3.42047 18.4205 4.91286 17.5 5.83333L6.49475 16.8386C6.2496 17.0837 6.12702 17.2063 5.98572 17.2995C5.86035 17.3821 5.72439 17.4475 5.58152 17.4937C5.42048 17.5459 5.24819 17.565 4.90362 17.6033L2.08331 17.9167L2.39668 15.0964Z",
  stroke: "#475467",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = {
  key: 41,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#22c55e",
  class: "w-14"
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_165 = [
  _hoisted_164
]
const _hoisted_166 = {
  key: 42,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_168 = [
  _hoisted_167
]
const _hoisted_169 = {
  key: 43,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_170 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_171 = [
  _hoisted_170
]
const _hoisted_172 = {
  key: 44,
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "19",
  viewBox: "0 0 23 19",
  fill: "none"
}
const _hoisted_173 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.56931 0.753221C7.75897 0.601557 7.99157 0.513459 8.23412 0.501422C8.47666 0.489385 8.71684 0.554019 8.92058 0.686158L9.01386 0.753221L12.0833 3L11.5833 3.5L11.0833 4L10.8709 4.21267L12.9166 6.55837H14.4583C14.8472 6.55824 15.2218 6.70514 15.507 6.9696C15.7922 7.23407 15.9669 7.59656 15.9961 7.98441L15.9999 8.10003V14.1896C16 14.3986 15.923 14.6002 15.7836 14.7558C15.6442 14.9114 15.4522 15.0101 15.2445 15.0329L7.08325 15.0375H1.43117C1.22223 15.0376 1.0206 14.9606 0.864976 14.8212C0.709346 14.6818 0.610671 14.4898 0.587877 14.2821L0.583252 14.1896V8.10003C0.583129 7.71109 0.730024 7.33647 0.994489 7.05128C1.25895 6.76608 1.62144 6.59139 2.00929 6.56222L2.12492 6.55837H3.66659V4.61587C3.66657 4.40827 3.70849 4.20281 3.78982 4.0118C3.87114 3.8208 3.99021 3.64819 4.13988 3.50433L4.24548 3.41183L7.56931 0.753221ZM8.29158 2.1492L5.20825 4.61587V13.4959H11.3749L10.8709 4.21267L8.29158 2.1492ZM14.4583 8.10003H12.9166V13.4959H14.4583V8.10003ZM3.66659 8.10003H2.12492V13.4959H3.66659V8.10003ZM8.29158 5.0167C8.59527 5.0167 8.89598 5.07651 9.17654 5.19273C9.45711 5.30894 9.71203 5.47928 9.92677 5.69402C10.1415 5.90875 10.3118 6.16368 10.4281 6.44424C10.5443 6.72481 10.6041 7.02552 10.6041 7.3292C10.6041 7.63288 10.5443 7.93359 10.4281 8.21416C10.3118 8.49472 10.1415 8.74965 9.92677 8.96439C9.71203 9.17912 9.45711 9.34946 9.17654 9.46567C8.89598 9.58189 8.59527 9.6417 8.29158 9.6417C7.67827 9.6417 7.09008 9.39806 6.6564 8.96439C6.22272 8.53071 5.97908 7.94251 5.97908 7.3292C5.97908 6.71589 6.22272 6.12769 6.6564 5.69402C7.09008 5.26034 7.67827 5.0167 8.29158 5.0167ZM8.29158 6.55837C8.08715 6.55837 7.89108 6.63958 7.74652 6.78414C7.60196 6.9287 7.52075 7.12476 7.52075 7.3292C7.52075 7.53364 7.60196 7.7297 7.74652 7.87426C7.89108 8.01882 8.08715 8.10003 8.29158 8.10003C8.49602 8.10003 8.69209 8.01882 8.83665 7.87426C8.98121 7.7297 9.06242 7.53364 9.06242 7.3292C9.06242 7.12476 8.98121 6.9287 8.83665 6.78414C8.69209 6.63958 8.49602 6.55837 8.29158 6.55837Z",
  fill: "white"
}, null, -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.2915 8V15L19.2146 15.5L20.2915 8.5L12.753 1.5L9.52227 4V6.5H7.90689C7.90689 6.5 7.16245 6.69126 6.82997 7C6.49748 7.30874 6.2915 8 6.2915 8Z",
  fill: "#8777FF"
}, null, -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.5693 1.75322C14.759 1.60156 14.9916 1.51346 15.2341 1.50142C15.4767 1.48938 15.7168 1.55402 15.9206 1.68616L16.0139 1.75322L19.3377 4.4126C19.4999 4.54221 19.6342 4.70324 19.7326 4.88603C19.831 5.06882 19.8915 5.26961 19.9104 5.47635L19.9166 5.61587V7.55837H21.4583C21.8472 7.55824 22.2218 7.70514 22.507 7.9696C22.7922 8.23407 22.9669 8.59656 22.9961 8.98441L22.9999 9.10003V15.1896C23 15.3986 22.923 15.6002 22.7836 15.7558C22.6442 15.9114 22.4522 16.0101 22.2445 16.0329L22.152 16.0375H8.43117C8.22223 16.0376 8.0206 15.9606 7.86498 15.8212C7.70935 15.6818 7.61067 15.4898 7.58788 15.2821L7.58325 15.1896V9.10003C7.58313 8.71109 7.73002 8.33647 7.99449 8.05128C8.25895 7.76608 8.62144 7.59139 9.00929 7.56222L9.12492 7.55837H10.6666V5.61587C10.6666 5.40827 10.7085 5.20281 10.7898 5.0118C10.8711 4.8208 10.9902 4.64819 11.1399 4.50433L11.2455 4.41183L14.5693 1.75245V1.75322ZM15.2916 3.1492L12.2083 5.61587V14.4959H18.3749V5.61587L15.2916 3.1492ZM21.4583 9.10003H19.9166V14.4959H21.4583V9.10003ZM10.6666 9.10003H9.12492V14.4959H10.6666V9.10003ZM15.2916 6.0167C15.5953 6.0167 15.896 6.07651 16.1765 6.19273C16.4571 6.30894 16.712 6.47928 16.9268 6.69402C17.1415 6.90875 17.3118 7.16368 17.4281 7.44424C17.5443 7.72481 17.6041 8.02552 17.6041 8.3292C17.6041 8.63288 17.5443 8.93359 17.4281 9.21416C17.3118 9.49472 17.1415 9.74965 16.9268 9.96439C16.712 10.1791 16.4571 10.3495 16.1765 10.4657C15.896 10.5819 15.5953 10.6417 15.2916 10.6417C14.6783 10.6417 14.0901 10.3981 13.6564 9.96439C13.2227 9.53071 12.9791 8.94251 12.9791 8.3292C12.9791 7.71589 13.2227 7.12769 13.6564 6.69402C14.0901 6.26034 14.6783 6.0167 15.2916 6.0167ZM15.2916 7.55837C15.0871 7.55837 14.8911 7.63958 14.7465 7.78414C14.602 7.9287 14.5208 8.12476 14.5208 8.3292C14.5208 8.53364 14.602 8.7297 14.7465 8.87426C14.8911 9.01882 15.0871 9.10003 15.2916 9.10003C15.496 9.10003 15.6921 9.01882 15.8366 8.87426C15.9812 8.7297 16.0624 8.53364 16.0624 8.3292C16.0624 8.12476 15.9812 7.9287 15.8366 7.78414C15.6921 7.63958 15.496 7.55837 15.2916 7.55837Z",
  fill: "white"
}, null, -1)
const _hoisted_176 = [
  _hoisted_173,
  _hoisted_174,
  _hoisted_175
]
const _hoisted_177 = {
  key: 45,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none"
}
const _hoisted_178 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_14976_2527)\"><path d=\"M1.17456 7.35938L8.66675 3.07812L16.1589 7.35938L8.66675 11.6406L1.17456 7.35938Z\" stroke=\"white\" stroke-width=\"1.07031\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.85034 8.96484V13.2461L8.66675 15.9219M8.66675 15.9219L13.4832 13.2461V8.96484M8.66675 15.9219V11.6406M16.1589 13.2461V7.35938\" stroke=\"white\" stroke-width=\"1.07031\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_14976_2527\"><rect width=\"17.125\" height=\"17.125\" fill=\"white\" transform=\"translate(0.104248 0.9375)\"></rect></clipPath></defs>", 2)
const _hoisted_180 = [
  _hoisted_178
]
const _hoisted_181 = {
  key: 46,
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
}, null, -1)
const _hoisted_183 = [
  _hoisted_182
]
const _hoisted_184 = {
  key: 47,
  class: "!w-[76px]",
  width: "78",
  height: "77",
  viewBox: "0 0 78 77",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_185 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.9375",
  width: "76.125",
  height: "76.125",
  rx: "38.0625",
  fill: "#FDA29B",
  "fill-opacity": "0.25"
}, null, -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.5005 36.4279C22.5005 29.9073 22.5005 26.646 24.5271 24.6212C26.5519 22.5946 29.8131 22.5946 36.3338 22.5946H43.2505C49.7712 22.5946 53.0324 22.5946 55.0572 24.6212C57.0838 26.646 57.0838 29.9073 57.0838 36.4279V39.8863C57.0838 46.407 57.0838 49.6682 55.0572 51.693C53.0324 53.7196 49.7712 53.7196 43.2505 53.7196H36.3338C29.8131 53.7196 26.5519 53.7196 24.5271 51.693C22.5005 49.6682 22.5005 46.407 22.5005 39.8863V36.4279Z",
  stroke: "#FDA29B",
  "stroke-width": "2.59375"
}, null, -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31.147 22.5946V20.0009M48.4386 22.5946V20.0009M23.3657 31.2404H56.2199",
  stroke: "#FDA29B",
  "stroke-width": "2.59375",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("path", {
  d: "M50.1665 45.0725C50.1665 45.5311 49.9843 45.9709 49.66 46.2952C49.3358 46.6195 48.8959 46.8016 48.4373 46.8016C47.9787 46.8016 47.5389 46.6195 47.2146 46.2952C46.8903 45.9709 46.7082 45.5311 46.7082 45.0725C46.7082 44.6139 46.8903 44.174 47.2146 43.8498C47.5389 43.5255 47.9787 43.3433 48.4373 43.3433C48.8959 43.3433 49.3358 43.5255 49.66 43.8498C49.9843 44.174 50.1665 44.6139 50.1665 45.0725ZM50.1665 38.1558C50.1665 38.6144 49.9843 39.0542 49.66 39.3785C49.3358 39.7028 48.8959 39.885 48.4373 39.885C47.9787 39.885 47.5389 39.7028 47.2146 39.3785C46.8903 39.0542 46.7082 38.6144 46.7082 38.1558C46.7082 37.6972 46.8903 37.2574 47.2146 36.9331C47.5389 36.6088 47.9787 36.4266 48.4373 36.4266C48.8959 36.4266 49.3358 36.6088 49.66 36.9331C49.9843 37.2574 50.1665 37.6972 50.1665 38.1558ZM41.5207 45.0725C41.5207 45.5311 41.3385 45.9709 41.0142 46.2952C40.6899 46.6195 40.2501 46.8016 39.7915 46.8016C39.3329 46.8016 38.8931 46.6195 38.5688 46.2952C38.2445 45.9709 38.0623 45.5311 38.0623 45.0725C38.0623 44.6139 38.2445 44.174 38.5688 43.8498C38.8931 43.5255 39.3329 43.3433 39.7915 43.3433C40.2501 43.3433 40.6899 43.5255 41.0142 43.8498C41.3385 44.174 41.5207 44.6139 41.5207 45.0725ZM41.5207 38.1558C41.5207 38.6144 41.3385 39.0542 41.0142 39.3785C40.6899 39.7028 40.2501 39.885 39.7915 39.885C39.3329 39.885 38.8931 39.7028 38.5688 39.3785C38.2445 39.0542 38.0623 38.6144 38.0623 38.1558C38.0623 37.6972 38.2445 37.2574 38.5688 36.9331C38.8931 36.6088 39.3329 36.4266 39.7915 36.4266C40.2501 36.4266 40.6899 36.6088 41.0142 36.9331C41.3385 37.2574 41.5207 37.6972 41.5207 38.1558ZM32.8748 45.0725C32.8748 45.5311 32.6927 45.9709 32.3684 46.2952C32.0441 46.6195 31.6043 46.8016 31.1457 46.8016C30.6871 46.8016 30.2472 46.6195 29.923 46.2952C29.5987 45.9709 29.4165 45.5311 29.4165 45.0725C29.4165 44.6139 29.5987 44.174 29.923 43.8498C30.2472 43.5255 30.6871 43.3433 31.1457 43.3433C31.6043 43.3433 32.0441 43.5255 32.3684 43.8498C32.6927 44.174 32.8748 44.6139 32.8748 45.0725ZM32.8748 38.1558C32.8748 38.6144 32.6927 39.0542 32.3684 39.3785C32.0441 39.7028 31.6043 39.885 31.1457 39.885C30.6871 39.885 30.2472 39.7028 29.923 39.3785C29.5987 39.0542 29.4165 38.6144 29.4165 38.1558C29.4165 37.6972 29.5987 37.2574 29.923 36.9331C30.2472 36.6088 30.6871 36.4266 31.1457 36.4266C31.6043 36.4266 32.0441 36.6088 32.3684 36.9331C32.6927 37.2574 32.8748 37.6972 32.8748 38.1558Z",
  fill: "#FDA29B"
}, null, -1)
const _hoisted_189 = [
  _hoisted_185,
  _hoisted_186,
  _hoisted_187,
  _hoisted_188
]
const _hoisted_190 = {
  key: 48,
  width: "78",
  height: "77",
  viewBox: "0 0 78 77",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_191 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.9375",
  width: "76.125",
  height: "76.125",
  rx: "38.0625",
  fill: "#53DDC9",
  "fill-opacity": "0.25"
}, null, -1)
const _hoisted_192 = /*#__PURE__*/_createElementVNode("path", {
  d: "M59.9167 25H33.375C31.1292 25 29.2917 26.8375 29.2917 29.0833V47.4583C29.2917 48.5413 29.7219 49.5799 30.4876 50.3457C31.2534 51.1115 32.292 51.5417 33.375 51.5417H59.9167C62.1829 51.5417 64 49.7246 64 47.4583V29.0833C64 28.0004 63.5698 26.9618 62.804 26.196C62.0382 25.4302 60.9996 25 59.9167 25ZM59.9167 47.4583H33.375V32.4929L46.6458 39.2917L59.9167 32.4929V47.4583ZM46.6458 35.8413L33.375 29.0833H59.9167L46.6458 35.8413ZM25.2083 47.4583C25.2083 47.8054 25.2696 48.1321 25.3104 48.4792H17.0417C15.9147 48.4792 15 47.5604 15 46.4375C15 45.3146 15.9147 44.3958 17.0417 44.3958H25.2083V47.4583ZM21.125 28.0625H25.3104C25.2696 28.4096 25.2083 28.7362 25.2083 29.0833V32.1458H21.125C20.0021 32.1458 19.0833 31.2271 19.0833 30.1042C19.0833 28.9812 20.0021 28.0625 21.125 28.0625ZM17.0417 38.2708C17.0417 37.1479 17.9604 36.2292 19.0833 36.2292H25.2083V40.3125H19.0833C17.9604 40.3125 17.0417 39.3937 17.0417 38.2708Z",
  fill: "#53DDC9"
}, null, -1)
const _hoisted_193 = [
  _hoisted_191,
  _hoisted_192
]
const _hoisted_194 = {
  key: 49,
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_195 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
  fill: "#828284"
}, null, -1)
const _hoisted_196 = [
  _hoisted_195
]
const _hoisted_197 = {
  key: 50,
  width: "131",
  height: "32",
  viewBox: "0 0 131 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_198 = /*#__PURE__*/_createStaticVNode("<path d=\"M13.2991 0C8.77743 0 4.32222 0.666667 0 2V16.6667C0 24.3333 5.31965 29.4667 13.2991 32C21.2786 29.4667 26.5983 24.3333 26.5983 16.6667V2C22.276 0.666667 17.8208 0 13.2991 0ZM19.9487 3.33333V16L13.2991 12L6.64957 16V3.33333C8.64443 2.66667 13.2991 2.66667 13.2991 2.66667C13.2991 2.66667 17.9538 2.66667 19.9487 3.33333ZM13.2991 29.2C10.4398 28.2667 7.84649 26.6667 5.71863 24.5333L13.2991 19.9333L20.8796 24.5333C18.7518 26.6667 16.1584 28.2667 13.2991 29.2Z\" fill=\"#4368FA\"></path><path d=\"M54.9919 8.6665H60.112L54.9919 24.6665H50.5367L48.0098 16.1332L45.483 24.6665H41.0278L35.9741 8.6665H41.0278L43.3551 17.2665L45.8155 8.6665H50.2707L52.731 17.2665L54.9919 8.6665Z\" fill=\"#27325E\"></path><path d=\"M74.2092 22.6664C70.9509 25.9997 65.6312 25.9997 62.3064 22.733C60.7106 21.133 59.7796 18.933 59.8461 16.6664C59.8461 11.9997 63.5699 8.19971 68.2246 8.19971C72.8793 8.19971 76.6695 11.933 76.6695 16.5997V16.6664C76.6695 18.933 75.8051 21.0664 74.2092 22.6664ZM65.6312 19.3997C67.0941 20.7997 69.4215 20.7997 70.8179 19.3997C71.5493 18.6664 71.8818 17.6664 71.8818 16.6664C71.9483 15.6664 71.5493 14.6664 70.8179 13.933C69.355 12.533 67.0276 12.533 65.6312 13.933C64.8998 14.6664 64.5008 15.6664 64.5673 16.6664C64.5008 17.6664 64.8998 18.6664 65.6312 19.3997Z\" fill=\"#27325E\"></path><path d=\"M87.8407 8.19988C89.4366 8.13322 90.966 8.79988 92.0964 9.93322C93.2933 11.2665 93.8918 12.9999 93.8253 14.7999V24.6665H89.0376V15.5332C89.1041 14.7332 88.8381 13.9332 88.2397 13.3999C87.7077 12.8666 86.9763 12.5999 86.2448 12.6666C85.4469 12.5999 84.6489 12.9332 84.1169 13.4666C83.5185 14.1332 83.2525 15.0665 83.319 15.9332V24.6665H78.5313V8.66655H83.319V10.1999C84.2499 8.86655 85.7793 8.19988 87.8407 8.19988Z\" fill=\"#27325E\"></path><path d=\"M107.789 3.79993L112.577 2.2666V24.6666H107.789V23.1333C106.593 24.4666 104.864 25.1999 103.068 25.0666C101.007 25.0666 99.012 24.1999 97.6821 22.5999C96.2192 20.9333 95.4213 18.7999 95.4878 16.5999C95.4213 14.3999 96.2192 12.2666 97.6821 10.5999C99.012 8.99994 101.007 8.13327 103.068 8.13327C104.864 7.99993 106.593 8.73327 107.789 10.0666V3.79993ZM101.273 19.5333C102.802 20.9333 105.196 20.9333 106.726 19.5333C107.457 18.7999 107.856 17.7333 107.789 16.6666C107.856 15.5999 107.457 14.5999 106.726 13.7999C105.196 12.3999 102.802 12.3999 101.273 13.7999C100.541 14.5333 100.142 15.5999 100.209 16.6666C100.209 17.7333 100.541 18.7333 101.273 19.5333Z\" fill=\"#27325E\"></path><path d=\"M119.493 18.5999C120.025 20.0665 121.288 20.8665 123.283 20.8665C124.413 20.9332 125.544 20.4665 126.342 19.6665L130.132 21.8665C128.536 24.0665 126.275 25.1332 123.216 25.1332C120.823 25.2665 118.562 24.3999 116.833 22.7332C115.237 21.1332 114.372 18.9332 114.439 16.6665C114.306 12.1332 117.83 8.3332 122.352 8.19987C122.551 8.19987 122.684 8.19987 122.884 8.19987C125.078 8.1332 127.14 8.99987 128.669 10.5999C130.198 12.1999 131.063 14.3999 130.996 16.5999C130.996 17.2665 130.93 17.8665 130.797 18.5332L119.493 18.5999ZM119.426 14.9999H126.275C125.943 13.3999 124.48 12.3332 122.884 12.4665C121.022 12.4665 119.892 13.3332 119.426 14.9999Z\" fill=\"#27325E\"></path>", 6)
const _hoisted_204 = [
  _hoisted_198
]
const _hoisted_205 = {
  key: 51,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_206 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#FEE4E2"
}, null, -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
  stroke: "#D92D20",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_208 = [
  _hoisted_206,
  _hoisted_207
]
const _hoisted_209 = {
  key: 52,
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_210 = /*#__PURE__*/_createElementVNode("rect", {
  width: "15",
  height: "15",
  rx: "7.5",
  fill: "#FDA29B"
}, null, -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.03125 9.0625V3.125H7.96875V9.0625H7.03125ZM7.03125 11.875V10.9375H7.96875V11.875H7.03125Z",
  fill: "white"
}, null, -1)
const _hoisted_212 = [
  _hoisted_210,
  _hoisted_211
]
const _hoisted_213 = {
  key: 53,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_214 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.4896 15.8866C21.3327 15.9696 19.3828 16.7394 18.3403 17.7831C18.2252 17.8982 18.0885 17.9895 17.938 18.0517C17.7876 18.114 17.6263 18.146 17.4635 18.146C17.3007 18.1459 17.1395 18.1138 16.9891 18.0514C16.8387 17.989 16.702 17.8977 16.5869 17.7825C16.4719 17.6673 16.3806 17.5306 16.3183 17.3802C16.2561 17.2297 16.2241 17.0685 16.2241 16.9057C16.2242 16.7429 16.2563 16.5816 16.3187 16.4312C16.381 16.2808 16.4724 16.1442 16.5876 16.0291C18.1953 14.4214 20.8133 13.509 23.3929 13.4086C25.9898 13.3082 28.8247 14.0185 30.8105 16.0043C31.043 16.2369 31.1735 16.5523 31.1734 16.8811C31.1733 17.21 31.0425 17.5253 30.8099 17.7577C30.5773 17.9901 30.2619 18.1207 29.9331 18.1205C29.6043 18.1204 29.289 17.9897 29.0565 17.7571C27.7054 16.4047 25.6303 15.8023 23.4896 15.8853V15.8866Z",
  fill: "#4B5563"
}, null, -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M36.1186 33.9448C38.5765 31.0402 39.9225 27.357 39.9167 23.5521C39.9167 14.6519 32.7023 7.4375 23.8021 7.4375C14.9019 7.4375 7.6875 14.6519 7.6875 23.5521C7.6875 32.4523 14.9019 39.6667 23.8021 39.6667C27.7626 39.6667 31.3883 38.2387 34.1948 35.8686L33.7188 38.6056L43.033 47.9198L48.1698 42.783L38.8556 33.4688L36.1186 33.9448ZM23.8021 35.9479C30.6483 35.9479 36.1979 30.3983 36.1979 23.5521C36.1979 16.7059 30.6483 11.1562 23.8021 11.1562C16.9559 11.1562 11.4062 16.7059 11.4062 23.5521C11.4062 30.3983 16.9559 35.9479 23.8021 35.9479Z",
  fill: "#4B5563"
}, null, -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("path", {
  d: "M44.7854 49.6726L49.9222 44.5358L51.6031 46.2166C52.5489 47.1624 52.5489 48.6958 51.6031 49.6404L49.89 51.3535C48.9442 52.2993 47.4108 52.2993 46.4663 51.3535L44.7854 49.6726Z",
  fill: "#4B5563"
}, null, -1)
const _hoisted_217 = [
  _hoisted_214,
  _hoisted_215,
  _hoisted_216
]
const _hoisted_218 = {
  key: 54,
  width: "78",
  height: "77",
  viewBox: "0 0 78 77",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_219 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.9375\" width=\"76.125\" height=\"76.125\" rx=\"38.0625\" fill=\"#E2DFFF\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.7504 33.0499C26.3152 33.0499 27.8159 32.4283 28.9223 31.3219C30.0288 30.2154 30.6504 28.7147 30.6504 27.1499C30.6504 25.5851 30.0288 24.0845 28.9223 22.978C27.8159 21.8715 26.3152 21.2499 24.7504 21.2499C23.1856 21.2499 21.6849 21.8715 20.5785 22.978C19.472 24.0845 18.8504 25.5851 18.8504 27.1499C18.8504 28.7147 19.472 30.2154 20.5785 31.3219C21.6849 32.4283 23.1856 33.0499 24.7504 33.0499ZM24.7504 35.9999C25.9126 35.9999 27.0634 35.771 28.1371 35.3263C29.2109 34.8815 30.1865 34.2296 31.0083 33.4078C31.8301 32.586 32.482 31.6104 32.9267 30.5367C33.3715 29.4629 33.6004 28.3121 33.6004 27.1499C33.6004 25.9877 33.3715 24.8369 32.9267 23.7632C32.482 22.6894 31.8301 21.7138 31.0083 20.892C30.1865 20.0702 29.2109 19.4183 28.1371 18.9736C27.0634 18.5288 25.9126 18.2999 24.7504 18.2999C22.4032 18.2999 20.1522 19.2323 18.4925 20.892C16.8328 22.5517 15.9004 24.8028 15.9004 27.1499C15.9004 29.4971 16.8328 31.7481 18.4925 33.4078C20.1522 35.0675 22.4032 35.9999 24.7504 35.9999Z\" fill=\"#8777FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.3701 32.7431C21.5074 32.8802 21.6164 33.0429 21.6908 33.2221C21.7651 33.4013 21.8034 33.5934 21.8034 33.7874C21.8034 33.9815 21.7651 34.1736 21.6908 34.3528C21.6164 34.532 21.5074 34.6947 21.3701 34.8317L20.373 35.8259C18.4541 37.7453 17.376 40.3482 17.3758 43.0622V48.5374C17.3758 48.9286 17.2204 49.3038 16.9438 49.5804C16.6671 49.857 16.292 50.0124 15.9008 50.0124C15.5096 50.0124 15.1344 49.857 14.8578 49.5804C14.5812 49.3038 14.4258 48.9286 14.4258 48.5374V43.0622C14.4262 39.5658 15.8152 36.2127 18.2873 33.7402L19.2815 32.7431C19.4185 32.6058 19.5813 32.4968 19.7605 32.4224C19.9397 32.3481 20.1318 32.3098 20.3258 32.3098C20.5198 32.3098 20.7119 32.3481 20.8911 32.4224C21.0703 32.4968 21.2331 32.6058 21.3701 32.7431ZM56.1565 31.8581C56.0191 31.9952 55.9101 32.1579 55.8358 32.3371C55.7614 32.5163 55.7231 32.7084 55.7231 32.9024C55.7231 33.0965 55.7614 33.2886 55.8358 33.4678C55.9101 33.647 56.0191 33.8097 56.1565 33.9467L57.1536 34.9409C58.1038 35.8912 58.8576 37.0194 59.3719 38.261C59.8861 39.5026 60.1508 40.8333 60.1508 42.1772V48.5374C60.1508 48.9286 60.3062 49.3038 60.5828 49.5804C60.8594 49.857 61.2346 50.0124 61.6258 50.0124C62.017 50.0124 62.3922 49.857 62.6688 49.5804C62.9454 49.3038 63.1008 48.9286 63.1008 48.5374V42.1772C63.1004 38.6808 61.7114 35.3277 59.2392 32.8552L58.2451 31.8581C58.1081 31.7208 57.9453 31.6118 57.7661 31.5374C57.5869 31.4631 57.3948 31.4248 57.2008 31.4248C57.0068 31.4248 56.8147 31.4631 56.6355 31.5374C56.4563 31.6118 56.2935 31.7208 56.1565 31.8581Z\" fill=\"#8777FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.3002 33.0499C49.7354 33.0499 48.2347 32.4283 47.1283 31.3219C46.0218 30.2154 45.4002 28.7147 45.4002 27.1499C45.4002 25.5851 46.0218 24.0845 47.1283 22.978C48.2347 21.8715 49.7354 21.2499 51.3002 21.2499C52.865 21.2499 54.3657 21.8715 55.4721 22.978C56.5786 24.0845 57.2002 25.5851 57.2002 27.1499C57.2002 28.7147 56.5786 30.2154 55.4721 31.3219C54.3657 32.4283 52.865 33.0499 51.3002 33.0499ZM51.3002 35.9999C50.138 35.9999 48.9872 35.771 47.9134 35.3263C46.8397 34.8815 45.8641 34.2296 45.0423 33.4078C44.2205 32.586 43.5686 31.6104 43.1239 30.5367C42.6791 29.4629 42.4502 28.3121 42.4502 27.1499C42.4502 25.9877 42.6791 24.8369 43.1239 23.7632C43.5686 22.6894 44.2205 21.7138 45.0423 20.892C45.8641 20.0702 46.8397 19.4183 47.9134 18.9736C48.9872 18.5288 50.138 18.2999 51.3002 18.2999C53.6474 18.2999 55.8984 19.2323 57.5581 20.892C59.2178 22.5517 60.1502 24.8028 60.1502 27.1499C60.1502 29.4971 59.2178 31.7481 57.5581 33.4078C55.8984 35.0675 53.6474 35.9999 51.3002 35.9999ZM38.0252 45.5874C36.0692 45.5874 34.1934 46.3644 32.8103 47.7475C31.4272 49.1306 30.6502 51.0065 30.6502 52.9624V56.7974C30.6502 57.1886 30.4948 57.5638 30.2182 57.8404C29.9416 58.117 29.5664 58.2724 29.1752 58.2724C28.784 58.2724 28.4088 58.117 28.1322 57.8404C27.8556 57.5638 27.7002 57.1886 27.7002 56.7974V52.9624C27.7002 50.2241 28.788 47.5979 30.7243 45.6615C32.6606 43.7252 35.2868 42.6374 38.0252 42.6374C40.7636 42.6374 43.3898 43.7252 45.3261 45.6615C47.2624 47.5979 48.3502 50.2241 48.3502 52.9624V56.7974C48.3502 57.1886 48.1948 57.5638 47.9182 57.8404C47.6416 58.117 47.2664 58.2724 46.8752 58.2724C46.484 58.2724 46.1088 58.117 45.8322 57.8404C45.5556 57.5638 45.4002 57.1886 45.4002 56.7974V52.9624C45.4002 51.9939 45.2094 51.0349 44.8388 50.1401C44.4682 49.2454 43.9249 48.4323 43.2401 47.7475C42.5553 47.0627 41.7423 46.5194 40.8475 46.1488C39.9527 45.7782 38.9937 45.5874 38.0252 45.5874Z\" fill=\"#8777FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.0258 41.1625C39.5906 41.1625 41.0912 40.5409 42.1977 39.4344C43.3042 38.3279 43.9258 36.8273 43.9258 35.2625C43.9258 33.6977 43.3042 32.197 42.1977 31.0905C41.0912 29.9841 39.5906 29.3625 38.0258 29.3625C36.461 29.3625 34.9603 29.9841 33.8539 31.0905C32.7474 32.197 32.1258 33.6977 32.1258 35.2625C32.1258 36.8273 32.7474 38.3279 33.8539 39.4344C34.9603 40.5409 36.461 41.1625 38.0258 41.1625ZM38.0258 44.1125C40.3729 44.1125 42.624 43.1801 44.2837 41.5204C45.9434 39.8607 46.8758 37.6096 46.8758 35.2625C46.8758 32.9153 45.9434 30.6643 44.2837 29.0046C42.624 27.3449 40.3729 26.4125 38.0258 26.4125C35.6786 26.4125 33.4276 27.3449 31.7679 29.0046C30.1082 30.6643 29.1758 32.9153 29.1758 35.2625C29.1758 37.6096 30.1082 39.8607 31.7679 41.5204C33.4276 43.1801 35.6786 44.1125 38.0258 44.1125Z\" fill=\"#8777FF\"></path>", 5)
const _hoisted_224 = [
  _hoisted_219
]
const _hoisted_225 = {
  key: 55,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_226 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#DCFAE6"
}, null, -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("path", {
  d: "M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
  stroke: "#079455",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_228 = [
  _hoisted_226,
  _hoisted_227
]
const _hoisted_229 = {
  key: 56,
  width: "78",
  height: "77",
  viewBox: "0 0 78 77",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_230 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.9375\" width=\"76.125\" height=\"76.125\" rx=\"38.0625\" fill=\"#155EEF\" fill-opacity=\"0.24\"></rect><g clip-path=\"url(#clip0_16203_15465)\"><path d=\"M39.5006 29.4282C41.8675 29.4282 43.7863 27.5095 43.7863 25.1425C43.7863 22.7756 41.8675 20.8568 39.5006 20.8568C37.1336 20.8568 35.2148 22.7756 35.2148 25.1425C35.2148 27.5095 37.1336 29.4282 39.5006 29.4282Z\" stroke=\"#155EEF\" stroke-width=\"2.85714\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M25.2149 55.1425C27.5818 55.1425 29.5006 53.2237 29.5006 50.8568C29.5006 48.4898 27.5818 46.571 25.2149 46.571C22.848 46.571 20.9292 48.4898 20.9292 50.8568C20.9292 53.2237 22.848 55.1425 25.2149 55.1425Z\" stroke=\"#155EEF\" stroke-width=\"2.85714\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M39.5006 55.1425C41.8675 55.1425 43.7863 53.2237 43.7863 50.8568C43.7863 48.4898 41.8675 46.571 39.5006 46.571C37.1336 46.571 35.2148 48.4898 35.2148 50.8568C35.2148 53.2237 37.1336 55.1425 39.5006 55.1425Z\" stroke=\"#155EEF\" stroke-width=\"2.85714\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M53.7862 55.1425C56.1531 55.1425 58.0719 53.2237 58.0719 50.8568C58.0719 48.4898 56.1531 46.571 53.7862 46.571C51.4193 46.571 49.5005 48.4898 49.5005 50.8568C49.5005 53.2237 51.4193 55.1425 53.7862 55.1425Z\" stroke=\"#155EEF\" stroke-width=\"2.85714\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M25.2148 46.5711V40.8568C25.2148 40.099 25.5159 39.3723 26.0517 38.8365C26.5875 38.3007 27.3142 37.9997 28.072 37.9997H50.9291C51.6869 37.9997 52.4136 38.3007 52.9494 38.8365C53.4853 39.3723 53.7863 40.099 53.7863 40.8568V46.5711M39.5006 29.4282V46.5711\" stroke=\"#155EEF\" stroke-width=\"2.85714\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_16203_15465\"><rect width=\"40\" height=\"40\" fill=\"white\" transform=\"translate(19.5 18)\"></rect></clipPath></defs>", 3)
const _hoisted_233 = [
  _hoisted_230
]
const _hoisted_234 = {
  key: 57,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5"
}
const _hoisted_235 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
}, null, -1)
const _hoisted_236 = [
  _hoisted_235
]
const _hoisted_237 = {
  key: 58,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  "data-slot": "icon",
  class: "-ml-0.5 h-5 w-5"
}
const _hoisted_238 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
}, null, -1)
const _hoisted_239 = [
  _hoisted_238
]
const _hoisted_240 = {
  key: 59,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}
const _hoisted_241 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#008000",
  d: "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
}, null, -1)
const _hoisted_242 = [
  _hoisted_241
]
const _hoisted_243 = {
  key: 60,
  class: "w-40 fill-blue-600",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 645 526"
}
const _hoisted_244 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "animate-[spin_5s_linear_infinite] origin-[461px_174px] fill-blue-600",
    d: "M635 184v-21l-29-4c-1-10-3-19-6-28l25-14 -8-19 -28 7c-5-8-10-16-16-24L592 58l-15-15 -23 17c-7-6-15-11-24-16l7-28 -19-8 -14 25c-9-3-18-5-28-6L472 0h-21l-4 29c-10 1-19 3-28 6L405 9l-19 8 7 28c-8 5-16 10-24 16l-23-17L331 58l17 23c-6 7-11 15-16 24l-28-7 -8 19 25 14c-3 9-5 18-6 28l-29 4v21l29 4c1 10 3 19 6 28l-25 14 8 19 28-7c5 8 10 16 16 24l-17 23 15 15 23-17c7 6 15 11 24 16l-7 28 19 8 14-25c9 3 18 5 28 6l4 29h21l4-29c10-1 19-3 28-6l14 25 19-8 -7-28c8-5 16-10 24-16l23 17 15-15 -17-23c6-7 11-15 16-24l28 7 8-19 -25-14c3-9 5-18 6-28L635 184zM461 284c-61 0-110-49-110-110S401 64 461 64s110 49 110 110S522 284 461 284z"
  })
], -1)
const _hoisted_245 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "animate-[spin_3.75s_linear_infinite] origin-[255px_380px] fill-blue-600",
    d: "M392 390v-21l-28-4c-1-10-4-19-7-28l23-17 -11-18L342 313c-6-8-13-14-20-20l11-26 -18-11 -17 23c-9-4-18-6-28-7l-4-28h-21l-4 28c-10 1-19 4-28 7l-17-23 -18 11 11 26c-8 6-14 13-20 20l-26-11 -11 18 23 17c-4 9-6 18-7 28l-28 4v21l28 4c1 10 4 19 7 28l-23 17 11 18 26-11c6 8 13 14 20 20l-11 26 18 11 17-23c9 4 18 6 28 7l4 28h21l4-28c10-1 19-4 28-7l17 23 18-11 -11-26c8-6 14-13 20-20l26 11 11-18 -23-17c4-9 6-18 7-28L392 390zM255 453c-41 0-74-33-74-74 0-41 33-74 74-74 41 0 74 33 74 74C328 420 295 453 255 453z"
  })
], -1)
const _hoisted_246 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "animate-[spin_2.5s_linear_infinite] origin-[100px_225px] fill-blue-600",
    d: "M200 236v-21l-29-4c-2-10-6-18-11-26l18-23 -15-15 -23 18c-8-5-17-9-26-11l-4-29H90l-4 29c-10 2-18 6-26 11l-23-18 -15 15 18 23c-5 8-9 17-11 26L0 215v21l29 4c2 10 6 18 11 26l-18 23 15 15 23-18c8 5 17 9 26 11l4 29h21l4-29c10-2 18-6 26-11l23 18 15-15 -18-23c5-8 9-17 11-26L200 236zM100 262c-20 0-37-17-37-37s17-37 37-37c20 0 37 17 37 37S121 262 100 262z"
  })
], -1)
const _hoisted_247 = [
  _hoisted_244,
  _hoisted_245,
  _hoisted_246
]
const _hoisted_248 = {
  key: 61,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_249 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5 7.5L10 12.5L15 7.5",
  stroke: "#475467",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_250 = [
  _hoisted_249
]
const _hoisted_251 = {
  key: 62,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_252 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_253 = [
  _hoisted_252
]
const _hoisted_254 = {
  key: 63,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_255 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z",
  stroke: "#344054",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_256 = [
  _hoisted_255
]
const _hoisted_257 = {
  key: 64,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  fill: "none"
}
const _hoisted_258 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 8.00006V14.0112C4 14.3702 4 14.5496 4.05465 14.7081C4.10299 14.8482 4.18187 14.9759 4.28558 15.0817C4.40287 15.2015 4.5634 15.2818 4.88446 15.4423L10.2845 18.1423C10.5468 18.2735 10.678 18.3391 10.8156 18.3649C10.9375 18.3877 11.0625 18.3877 11.1844 18.3649C11.322 18.3391 11.4532 18.2735 11.7155 18.1423L17.1155 15.4423C17.4366 15.2818 17.5971 15.2015 17.7144 15.0817C17.8181 14.9759 17.897 14.8482 17.9453 14.7081C18 14.5496 18 14.3702 18 14.0112V8.00006M1 6.50006L10.6422 1.67895C10.7734 1.61336 10.839 1.58056 10.9078 1.56766C10.9687 1.55622 11.0313 1.55622 11.0922 1.56766C11.161 1.58056 11.2266 1.61336 11.3578 1.67895L21 6.50006L11.3578 11.3212C11.2266 11.3868 11.161 11.4196 11.0922 11.4325C11.0313 11.4439 10.9687 11.4439 10.9078 11.4325C10.839 11.4196 10.7734 11.3868 10.6422 11.3212L1 6.50006Z",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_259 = [
  _hoisted_258
]
const _hoisted_260 = {
  key: 65,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  fill: "none"
}
const _hoisted_261 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_262 = [
  _hoisted_261
]
const _hoisted_263 = {
  key: 66,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none"
}
const _hoisted_264 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17 19C17 17.6044 17 16.9067 16.8278 16.3389C16.44 15.0605 15.4395 14.06 14.1611 13.6722C13.5933 13.5 12.8956 13.5 11.5 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_265 = [
  _hoisted_264
]
const _hoisted_266 = {
  key: 67,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}
const _hoisted_267 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 15.9997H14M9.0177 1.76375L2.23539 7.03888C1.78202 7.3915 1.55534 7.56781 1.39203 7.78861C1.24737 7.9842 1.1396 8.20454 1.07403 8.43881C1 8.70327 1 8.99045 1 9.56481V16.7997C1 17.9198 1 18.4799 1.21799 18.9077C1.40973 19.284 1.71569 19.59 2.09202 19.7818C2.51984 19.9997 3.07989 19.9997 4.2 19.9997H15.8C16.9201 19.9997 17.4802 19.9997 17.908 19.7818C18.2843 19.59 18.5903 19.284 18.782 18.9077C19 18.4799 19 17.9198 19 16.7997V9.56481C19 8.99045 19 8.70327 18.926 8.43881C18.8604 8.20454 18.7526 7.9842 18.608 7.78861C18.4447 7.56781 18.218 7.3915 17.7646 7.03888L10.9823 1.76376C10.631 1.4905 10.4553 1.35388 10.2613 1.30136C10.0902 1.25502 9.9098 1.25502 9.73865 1.30136C9.54468 1.35388 9.36902 1.4905 9.0177 1.76375Z",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_268 = [
  _hoisted_267
]
const _hoisted_269 = {
  key: 68,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_270 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 13V15M10 9V15M14 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_271 = [
  _hoisted_270
]
const _hoisted_272 = {
  key: 69,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  fill: "none"
}
const _hoisted_273 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21 10H17L14 19L8 1L5 10H1",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_274 = [
  _hoisted_273
]
const _hoisted_275 = {
  key: 70,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none"
}
const _hoisted_276 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 1C12.3132 1 13.6136 1.25866 14.8268 1.76121C16.0401 2.26375 17.1425 3.00035 18.0711 3.92893C18.9997 4.85752 19.7363 5.95991 20.2388 7.17317C20.7413 8.38643 21 9.68679 21 11M11 1V11M11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5229 21 11M11 1C16.5228 1 21 5.47716 21 11M21 11L11 11M21 11C21 12.5781 20.6265 14.1338 19.9101 15.5399C19.1936 16.946 18.1546 18.1626 16.8779 19.0902L11 11",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_277 = [
  _hoisted_276
]
const _hoisted_278 = {
  key: 71,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17",
  viewBox: "0 0 20 17",
  fill: "none"
}
const _hoisted_279 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.1667 10.0833V7.57866C14.1667 7.4291 14.1667 7.35431 14.144 7.28829C14.1238 7.22991 14.091 7.17673 14.0478 7.1326C13.9989 7.08271 13.932 7.04926 13.7982 6.98238L10.0001 5.08331M3.33341 5.91664V11.5888C3.33341 11.8987 3.33341 12.0537 3.38176 12.1894C3.4245 12.3093 3.49417 12.4179 3.5854 12.5067C3.68859 12.6072 3.82948 12.6718 4.11121 12.8009L9.44454 15.2454C9.6489 15.339 9.75108 15.3859 9.85753 15.4043C9.95186 15.4207 10.0483 15.4207 10.1426 15.4043C10.2491 15.3859 10.3513 15.339 10.5556 15.2454L15.889 12.8009C16.1707 12.6718 16.3116 12.6072 16.4148 12.5067C16.506 12.4179 16.5757 12.3093 16.6184 12.1894C16.6667 12.0537 16.6667 11.8987 16.6667 11.5888V5.91664M1.66675 5.08331L9.70194 1.06571C9.81126 1.01105 9.86592 0.983722 9.92325 0.972965C9.97403 0.963439 10.0261 0.963439 10.0769 0.972965C10.1342 0.983722 10.1889 1.01105 10.2982 1.06571L18.3334 5.08331L10.2982 9.1009C10.1889 9.15556 10.1342 9.18289 10.0769 9.19365C10.0261 9.20317 9.97403 9.20317 9.92325 9.19365C9.86592 9.18289 9.81126 9.15556 9.70194 9.1009L1.66675 5.08331Z",
  stroke: "#344054",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_280 = [
  _hoisted_279
]
const _hoisted_281 = {
  key: 72,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_282 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#D1E0FF"
}, null, -1)
const _hoisted_283 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.302 33.6149C23.5234 33.744 23.6341 33.8086 23.7903 33.8421C23.9116 33.8681 24.0884 33.8681 24.2097 33.8421C24.3659 33.8086 24.4766 33.744 24.698 33.6149C26.646 32.4784 32 28.9084 32 24V19.2176C32 18.4181 32 18.0183 31.8692 17.6747C31.7537 17.3711 31.566 17.1003 31.3223 16.8855C31.0465 16.6424 30.6722 16.5021 29.9236 16.2213L24.5618 14.2107C24.3539 14.1327 24.25 14.0937 24.143 14.0783C24.0482 14.0646 23.9518 14.0646 23.857 14.0783C23.75 14.0937 23.6461 14.1327 23.4382 14.2107L18.0764 16.2213C17.3278 16.5021 16.9535 16.6424 16.6777 16.8855C16.434 17.1003 16.2463 17.3711 16.1308 17.6747C16 18.0183 16 18.4181 16 19.2176V24C16 28.9084 21.354 32.4784 23.302 33.6149Z",
  stroke: "#155EEF",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_284 = [
  _hoisted_282,
  _hoisted_283
]
const _hoisted_285 = {
  key: 73,
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_286 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
  fill: "#FEE4E2"
}, null, -1)
const _hoisted_287 = /*#__PURE__*/_createElementVNode("path", {
  d: "M28 18V17.2C28 16.0799 28 15.5198 27.782 15.092C27.5903 14.7157 27.2843 14.4097 26.908 14.218C26.4802 14 25.9201 14 24.8 14H23.2C22.0799 14 21.5198 14 21.092 14.218C20.7157 14.4097 20.4097 14.7157 20.218 15.092C20 15.5198 20 16.0799 20 17.2V18M22 23.5V28.5M26 23.5V28.5M15 18H33M31 18V29.2C31 30.8802 31 31.7202 30.673 32.362C30.3854 32.9265 29.9265 33.3854 29.362 33.673C28.7202 34 27.8802 34 26.2 34H21.8C20.1198 34 19.2798 34 18.638 33.673C18.0735 33.3854 17.6146 32.9265 17.327 32.362C17 31.7202 17 30.8802 17 29.2V18",
  stroke: "#D92D20",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_288 = [
  _hoisted_286,
  _hoisted_287
]
const _hoisted_289 = {
  key: 74,
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  fill: "none"
}
const _hoisted_290 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.666748 7.99984L4.00008 11.3332L7.33341 7.99984M0.666748 3.99984L4.00008 0.666504L7.33341 3.99984",
  stroke: "#475467",
  "stroke-width": "1.33",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_291 = [
  _hoisted_290
]
const _hoisted_292 = {
  key: 75,
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_293 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16H7.5C6.10444 16 5.40665 16 4.83886 16.1722C3.56045 16.56 2.56004 17.5605 2.17224 18.8389C2 19.4067 2 20.1044 2 21.5M19 21.5V15.5M16 18.5H22M14.5 8C14.5 10.4853 12.4853 12.5 10 12.5C7.51472 12.5 5.5 10.4853 5.5 8C5.5 5.51472 7.51472 3.5 10 3.5C12.4853 3.5 14.5 5.51472 14.5 8Z",
  stroke: "#344054",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_294 = [
  _hoisted_293
]
const _hoisted_295 = {
  key: 76,
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_296 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 16H7.5C6.10444 16 5.40665 16 4.83886 16.1722C3.56045 16.56 2.56004 17.5605 2.17224 18.8389C2 19.4067 2 20.1044 2 21.5M14.5 8C14.5 10.4853 12.4853 12.5 10 12.5C7.51472 12.5 5.5 10.4853 5.5 8C5.5 5.51472 7.51472 3.5 10 3.5C12.4853 3.5 14.5 5.51472 14.5 8ZM11 21.5L14.1014 20.6139C14.2499 20.5715 14.3241 20.5502 14.3934 20.5184C14.4549 20.4902 14.5134 20.4558 14.5679 20.4158C14.6293 20.3707 14.6839 20.3161 14.7932 20.2068L21.25 13.75C21.9404 13.0597 21.9404 11.9403 21.25 11.25C20.5597 10.5596 19.4404 10.5596 18.75 11.25L12.2932 17.7068C12.1839 17.8161 12.1293 17.8707 12.0842 17.9321C12.0442 17.9866 12.0098 18.0451 11.9816 18.1066C11.9497 18.1759 11.9285 18.2501 11.8861 18.3987L11 21.5Z",
  stroke: "#344054",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_297 = [
  _hoisted_296
]
const _hoisted_298 = {
  key: 77,
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "53",
  viewBox: "0 0 52 53",
  fill: "none"
}
const _hoisted_299 = /*#__PURE__*/_createStaticVNode("<g filter=\"url(#filter0_d_1991_5137)\"><path d=\"M12 2H40C45.2467 2 49.5 6.25329 49.5 11.5V39.5C49.5 44.7467 45.2467 49 40 49H12C6.7533 49 2.5 44.7467 2.5 39.5V11.5C2.5 6.2533 6.75329 2 12 2Z\" stroke=\"#EAECF0\" shape-rendering=\"crispEdges\"></path><path d=\"M26 29H21.5C20.1044 29 19.4067 29 18.8389 29.1722C17.5605 29.56 16.56 30.5605 16.1722 31.8389C16 32.4067 16 33.1044 16 34.5M33 34.5V28.5M30 31.5H36M28.5 21C28.5 23.4853 26.4853 25.5 24 25.5C21.5147 25.5 19.5 23.4853 19.5 21C19.5 18.5147 21.5147 16.5 24 16.5C26.4853 16.5 28.5 18.5147 28.5 21Z\" stroke=\"#344054\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><filter id=\"filter0_d_1991_5137\" x=\"0\" y=\"0.5\" width=\"52\" height=\"52\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dy=\"1\"></feOffset><feGaussianBlur stdDeviation=\"1\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1991_5137\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1991_5137\" result=\"shape\"></feBlend></filter></defs>", 2)
const _hoisted_301 = [
  _hoisted_299
]
const _hoisted_302 = {
  key: 78,
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "53",
  viewBox: "0 0 52 53",
  fill: "none"
}
const _hoisted_303 = /*#__PURE__*/_createStaticVNode("<g filter=\"url(#filter0_d_2049_1505)\"><path d=\"M12 2H40C45.2467 2 49.5 6.25329 49.5 11.5V39.5C49.5 44.7467 45.2467 49 40 49H12C6.7533 49 2.5 44.7467 2.5 39.5V11.5C2.5 6.2533 6.75329 2 12 2Z\" stroke=\"#EAECF0\" shape-rendering=\"crispEdges\"></path><path d=\"M23 29H21.5C20.1044 29 19.4067 29 18.8389 29.1722C17.5605 29.56 16.56 30.5605 16.1722 31.8389C16 32.4067 16 33.1044 16 34.5M28.5 21C28.5 23.4853 26.4853 25.5 24 25.5C21.5147 25.5 19.5 23.4853 19.5 21C19.5 18.5147 21.5147 16.5 24 16.5C26.4853 16.5 28.5 18.5147 28.5 21ZM25 34.5L28.1014 33.6139C28.2499 33.5715 28.3241 33.5502 28.3934 33.5184C28.4549 33.4902 28.5134 33.4558 28.5679 33.4158C28.6293 33.3707 28.6839 33.3161 28.7932 33.2068L35.25 26.75C35.9404 26.0597 35.9404 24.9403 35.25 24.25C34.5597 23.5596 33.4404 23.5596 32.75 24.25L26.2932 30.7068C26.1839 30.8161 26.1293 30.8707 26.0842 30.9321C26.0442 30.9866 26.0098 31.0451 25.9816 31.1066C25.9497 31.1759 25.9285 31.2501 25.8861 31.3987L25 34.5Z\" stroke=\"#344054\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><filter id=\"filter0_d_2049_1505\" x=\"0\" y=\"0.5\" width=\"52\" height=\"52\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dy=\"1\"></feOffset><feGaussianBlur stdDeviation=\"1\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2049_1505\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2049_1505\" result=\"shape\"></feBlend></filter></defs>", 2)
const _hoisted_305 = [
  _hoisted_303
]
const _hoisted_306 = {
  key: 79,
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none"
}
const _hoisted_307 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z",
  fill: "#FEE4E2"
}, null, -1)
const _hoisted_308 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 13.8335V16.5002M16 19.1668H16.0066M22.6666 16.5002C22.6666 20.1821 19.6819 23.1668 16 23.1668C12.3181 23.1668 9.33331 20.1821 9.33331 16.5002C9.33331 12.8183 12.3181 9.8335 16 9.8335C19.6819 9.8335 22.6666 12.8183 22.6666 16.5002Z",
  stroke: "#D92D20",
  "stroke-width": "1.33333",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_309 = [
  _hoisted_307,
  _hoisted_308
]
const _hoisted_310 = {
  key: 80,
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-6"
}
const _hoisted_311 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
}, null, -1)
const _hoisted_312 = [
  _hoisted_311
]
const _hoisted_313 = {
  key: 81,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_314 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5 10V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V10M13.3333 5.83333L10 2.5M10 2.5L6.66667 5.83333M10 2.5V12.5",
  stroke: "#344054",
  "stroke-width": "1.66667",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_315 = [
  _hoisted_314
]
const _hoisted_316 = {
  key: 82,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_317 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2144_422)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.9998 5.83317V4.33317C14.9998 3.39975 14.9998 2.93304 14.8182 2.57652C14.6584 2.26292 14.4034 2.00795 14.0898 1.84816C13.7333 1.6665 13.2666 1.6665 12.3332 1.6665H7.6665C6.73308 1.6665 6.26637 1.6665 5.90985 1.84816C5.59625 2.00795 5.34128 2.26292 5.18149 2.57652C4.99984 2.93304 4.99984 3.39975 4.99984 4.33317V5.83317M4.99984 14.9998C4.22486 14.9998 3.83737 14.9998 3.51946 14.9147C2.65673 14.6835 1.98286 14.0096 1.75169 13.1469C1.6665 12.829 1.6665 12.4415 1.6665 11.6665V9.83317C1.6665 8.43304 1.6665 7.73297 1.93899 7.19819C2.17867 6.72779 2.56112 6.34534 3.03153 6.10565C3.56631 5.83317 4.26637 5.83317 5.6665 5.83317H14.3332C15.7333 5.83317 16.4334 5.83317 16.9681 6.10565C17.4386 6.34534 17.821 6.72779 18.0607 7.19819C18.3332 7.73297 18.3332 8.43304 18.3332 9.83317V11.6665C18.3332 12.4415 18.3332 12.829 18.248 13.1469C18.0168 14.0096 17.3429 14.6835 16.4802 14.9147C16.1623 14.9998 15.7748 14.9998 14.9998 14.9998M12.4998 8.74984H14.9998M7.6665 18.3332H12.3332C13.2666 18.3332 13.7333 18.3332 14.0898 18.1515C14.4034 17.9917 14.6584 17.7368 14.8182 17.4232C14.9998 17.0666 14.9998 16.5999 14.9998 15.6665V14.3332C14.9998 13.3998 14.9998 12.933 14.8182 12.5765C14.6584 12.2629 14.4034 12.0079 14.0898 11.8482C13.7333 11.6665 13.2666 11.6665 12.3332 11.6665H7.6665C6.73308 11.6665 6.26637 11.6665 5.90985 11.8482C5.59625 12.0079 5.34128 12.2629 5.18149 12.5765C4.99984 12.933 4.99984 13.3998 4.99984 14.3332V15.6665C4.99984 16.5999 4.99984 17.0666 5.18149 17.4232C5.34128 17.7368 5.59625 17.9917 5.90985 18.1515C6.26637 18.3332 6.73308 18.3332 7.6665 18.3332Z",
    stroke: "#344054",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_318 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2144_422" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)
const _hoisted_319 = [
  _hoisted_317,
  _hoisted_318
]
const _hoisted_320 = {
  key: 83,
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none"
}
const _hoisted_321 = /*#__PURE__*/_createStaticVNode("<g filter=\"url(#filter0_d_2222_2031)\"><path d=\"M12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.7533 48.5 2.5 44.2467 2.5 39V11C2.5 5.7533 6.75329 1.5 12 1.5Z\" stroke=\"#EAECF0\" shape-rendering=\"crispEdges\"></path><path d=\"M34 34C34 32.6044 34 31.9067 33.8278 31.3389C33.44 30.0605 32.4395 29.06 31.1611 28.6722C30.5933 28.5 29.8956 28.5 28.5 28.5H23.5C22.1044 28.5 21.4067 28.5 20.8389 28.6722C19.5605 29.06 18.56 30.0605 18.1722 31.3389C18 31.9067 18 32.6044 18 34M30.5 20.5C30.5 22.9853 28.4853 25 26 25C23.5147 25 21.5 22.9853 21.5 20.5C21.5 18.0147 23.5147 16 26 16C28.4853 16 30.5 18.0147 30.5 20.5Z\" stroke=\"#344054\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><filter id=\"filter0_d_2222_2031\" x=\"0\" y=\"0\" width=\"52\" height=\"52\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dy=\"1\"></feOffset><feGaussianBlur stdDeviation=\"1\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2222_2031\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2222_2031\" result=\"shape\"></feBlend></filter></defs>", 2)
const _hoisted_323 = [
  _hoisted_321
]
const _hoisted_324 = {
  key: 84,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_325 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.913 17H20.087M12.913 17L11 21M12.913 17L15.7783 11.009C16.0092 10.5263 16.1246 10.2849 16.2826 10.2086C16.4199 10.1423 16.5801 10.1423 16.7174 10.2086C16.8754 10.2849 16.9908 10.5263 17.2217 11.009L20.087 17M20.087 17L22 21M2 5H8M8 5H11.5M8 5V3M11.5 5H14M11.5 5C11.0039 7.95729 9.85259 10.6362 8.16555 12.8844M10 14C9.38747 13.7248 8.76265 13.3421 8.16555 12.8844M8.16555 12.8844C6.81302 11.8478 5.60276 10.4266 5 9M8.16555 12.8844C6.56086 15.0229 4.47143 16.7718 2 18",
  stroke: "#667085",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_326 = [
  _hoisted_325
]
const _hoisted_327 = {
  key: 85,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_328 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
  stroke: "#344054",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_329 = [
  _hoisted_328
]

import { defineOptions } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'RLIconComponent',
  props: {
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.icon == 'bold')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (props.icon == 'rl-overview')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (props.icon == 'rl-journeys')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    (props.icon == 'rl-progress')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true),
    (props.icon == 'rl-activity')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (props.icon == 'rl-reports')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true),
    (props.icon == 'rl-students')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
      : _createCommentVNode("", true),
    (props.icon == 'rl-admin')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
      : _createCommentVNode("", true),
    (props.icon == 'rl-super-admin')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
      : _createCommentVNode("", true),
    (props.icon == 'rl-internal')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_31))
      : _createCommentVNode("", true),
    (props.icon == 'rl-english-icon')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_50))
      : _createCommentVNode("", true),
    (props.icon == 'rl-math-icon')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_62))
      : _createCommentVNode("", true),
    (props.icon == 'rl-menu')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_63, _hoisted_65))
      : _createCommentVNode("", true),
    (props.icon == 'rl-chat-bubbles')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_66, _hoisted_68))
      : _createCommentVNode("", true),
    (props.icon == 'rl-info-circle')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_69, _hoisted_72))
      : _createCommentVNode("", true),
    (props.icon == 'rl-logout')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_73, _hoisted_75))
      : _createCommentVNode("", true),
    (props.icon == 'rl-loader')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_76, _hoisted_79))
      : _createCommentVNode("", true),
    (props.icon == 'rl-filter')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_80, _hoisted_82))
      : _createCommentVNode("", true),
    (props.icon == 'rl-email')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_83, _hoisted_85))
      : _createCommentVNode("", true),
    (props.icon == 'rl-trash')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_88))
      : _createCommentVNode("", true),
    (props.icon == 'rl-plus')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_89, _hoisted_91))
      : _createCommentVNode("", true),
    (props.icon == 'rl-back-arrow')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_92, _hoisted_95))
      : _createCommentVNode("", true),
    (props.icon == 'rl-profile')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_96, _hoisted_100))
      : _createCommentVNode("", true),
    (props.icon == 'rl-large-close')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_101, _hoisted_103))
      : _createCommentVNode("", true),
    (props.icon == 'rl-green-save')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_104, _hoisted_107))
      : _createCommentVNode("", true),
    (props.icon == 'rl-red-fail')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_108, _hoisted_111))
      : _createCommentVNode("", true),
    (props.icon == 'rl-question-cirlce')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_112, _hoisted_115))
      : _createCommentVNode("", true),
    (props.icon == 'rl-green-tick')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_116, _hoisted_119))
      : _createCommentVNode("", true),
    (props.icon == 'rl-question-speech-bubble')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_120, _hoisted_123))
      : _createCommentVNode("", true),
    (props.icon == 'rl-file-upload')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_124, _hoisted_126))
      : _createCommentVNode("", true),
    (props.icon == 'rl-arrow-up')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_127, _hoisted_129))
      : _createCommentVNode("", true),
    (props.icon == 'rl-arrow-down')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_130, _hoisted_132))
      : _createCommentVNode("", true),
    (props.icon == 'rl-green-person')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_133, _hoisted_136))
      : _createCommentVNode("", true),
    (props.icon == 'rl-green-trophy')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_137, _hoisted_139))
      : _createCommentVNode("", true),
    (props.icon == 'rl-dark-arrow-up')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_140, _hoisted_142))
      : _createCommentVNode("", true),
    (props.icon == 'rl-dark-arrow-down')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_143, _hoisted_145))
      : _createCommentVNode("", true),
    (props.icon == 'rl-small-back-arrow')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_146, _hoisted_148))
      : _createCommentVNode("", true),
    (props.icon == 'rl-pink-alert')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_149, _hoisted_152))
      : _createCommentVNode("", true),
    (props.icon == 'rl-yellow-alert')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_153, _hoisted_156))
      : _createCommentVNode("", true),
    (props.icon == 'rl-bulk-upload')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_157, _hoisted_159))
      : _createCommentVNode("", true),
    (props.icon == 'rl-bulk-edit')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_160, _hoisted_162))
      : _createCommentVNode("", true),
    (props.icon == 'rl-green-user')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_163, _hoisted_165))
      : _createCommentVNode("", true),
    (props.icon == 'rl-circle-plus')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_166, _hoisted_168))
      : _createCommentVNode("", true),
    (props.icon == 'rl-circle-minus')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_169, _hoisted_171))
      : _createCommentVNode("", true),
    (props.icon == 'rl-school-group')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_172, _hoisted_176))
      : _createCommentVNode("", true),
    (props.icon == 'rl-archive-school')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_177, _hoisted_180))
      : _createCommentVNode("", true),
    (props.icon == 'rl-learners-icon')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_181, _hoisted_183))
      : _createCommentVNode("", true),
    (props.icon == 'rl-rollover-red-calender')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_184, _hoisted_189))
      : _createCommentVNode("", true),
    (props.icon == 'rl-rollover-mail')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_190, _hoisted_193))
      : _createCommentVNode("", true),
    (props.icon == 'rl-small-close')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_194, _hoisted_196))
      : _createCommentVNode("", true),
    (props.icon == 'rl-wonde-logo')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_197, _hoisted_204))
      : _createCommentVNode("", true),
    (props.icon == 'rl-exclamation-bg-logo')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_205, _hoisted_208))
      : _createCommentVNode("", true),
    (props.icon == 'rl-exclamation-small')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_209, _hoisted_212))
      : _createCommentVNode("", true),
    (props.icon == 'rl-magnifying-glass')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_213, _hoisted_217))
      : _createCommentVNode("", true),
    (props.icon == 'rl-group-of-people')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_218, _hoisted_224))
      : _createCommentVNode("", true),
    (props.icon == 'rl-two-people')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_225, _hoisted_228))
      : _createCommentVNode("", true),
    (props.icon == 'rl-team-collaboration')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_229, _hoisted_233))
      : _createCommentVNode("", true),
    (props.icon == 'rl-right-arrow')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_234, _hoisted_236))
      : _createCommentVNode("", true),
    (props.icon == 'rl-reload-icon')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_237, _hoisted_239))
      : _createCommentVNode("", true),
    (props.icon == 'rl-report-icon')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_240, _hoisted_242))
      : _createCommentVNode("", true),
    (props.icon == 'rl-spinning-gears')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_243, _hoisted_247))
      : _createCommentVNode("", true),
    (props.icon == 'rl-down-center-arrow')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_248, _hoisted_250))
      : _createCommentVNode("", true),
    (props.icon == 'rl-class-reports')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_251, _hoisted_253))
      : _createCommentVNode("", true),
    (props.icon == 'rl-circle')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_254, _hoisted_256))
      : _createCommentVNode("", true),
    (props.icon == 'rl-hat')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_257, _hoisted_259))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-classes')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_260, _hoisted_262))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-students')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_263, _hoisted_265))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-home')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_266, _hoisted_268))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-journeys')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_269, _hoisted_271))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-activity')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_272, _hoisted_274))
      : _createCommentVNode("", true),
    (props.icon == 'rl-grey-reports')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_275, _hoisted_277))
      : _createCommentVNode("", true),
    (props.icon == 'rl-school-champ')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_278, _hoisted_280))
      : _createCommentVNode("", true),
    (props.icon == 'rl-shield')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_281, _hoisted_284))
      : _createCommentVNode("", true),
    (props.icon == 'rl-delete')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_285, _hoisted_288))
      : _createCommentVNode("", true),
    (props.icon == 'rl-sort-arrows')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_289, _hoisted_291))
      : _createCommentVNode("", true),
    (props.icon == 'rl-add-user')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_292, _hoisted_294))
      : _createCommentVNode("", true),
    (props.icon == 'rl-edit-user')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_295, _hoisted_297))
      : _createCommentVNode("", true),
    (props.icon == 'rl-add-teacher')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_298, _hoisted_301))
      : _createCommentVNode("", true),
    (props.icon == 'rl-edit-teacher')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_302, _hoisted_305))
      : _createCommentVNode("", true),
    (props.icon == 'rl-alert-error')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_306, _hoisted_309))
      : _createCommentVNode("", true),
    (props.icon == 'rl-download')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_310, _hoisted_312))
      : _createCommentVNode("", true),
    (props.icon == 'rl-export')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_313, _hoisted_315))
      : _createCommentVNode("", true),
    (props.icon == 'rl-printer')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_316, _hoisted_319))
      : _createCommentVNode("", true),
    (props.icon == 'rl-user')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_320, _hoisted_323))
      : _createCommentVNode("", true),
    (props.icon == 'rl-lingo')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_324, _hoisted_326))
      : _createCommentVNode("", true),
    (props.icon == 'rl-lingo-lists')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_327, _hoisted_329))
      : _createCommentVNode("", true)
  ], 64))
}
}

})